import { LazyLoadImage } from 'react-lazy-load-image-component';

import { StaticImage } from '@/common/constants/displateRoutes';
import {
  FooterInfoBoxHeader,
  FooterInfoBoxMultipleIconWrapper,
  FooterInfoBoxText,
  FooterInfoBoxWrapper,
} from '@/modules/ProductPage/components/Footer/FooterInfoBox.styled';
import { providerImageData } from '@/modules/ProductPage/components/Footer/providerImageData';

const FooterDeliveryBox = () => {
  return (
    <FooterInfoBoxWrapper>
      <FooterInfoBoxHeader>Fast delivery</FooterInfoBoxHeader>
      <FooterInfoBoxText>At your door in a few days</FooterInfoBoxText>
      <FooterInfoBoxMultipleIconWrapper>
        {providerImageData.map((image, index) => (
          <LazyLoadImage alt={image.alt} key={index} src={StaticImage(image.src)} />
        ))}
      </FooterInfoBoxMultipleIconWrapper>
    </FooterInfoBoxWrapper>
  );
};

export default FooterDeliveryBox;
